import d3 from "@/plugins/d3";
import { mapGetters, mapActions } from "vuex";

import { percentage, percentageNoRound, commas } from "@/filters";
import { getCSSVarHex, debounceAF } from "@/helpers/utils";

export default {
  data() {
    return {
      g: null,
      svg: null,
      mapElement: null,
      standardCityOffset: {
        textAnchor: "start",
        offsetLeft: 10,
        offsetTop: 2,
      },
      citiesWithOffsets: [
        {
          state: "Wisconsin",
          name: "Green Bay",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Wisconsin",
          name: "Milwaukee",
          textAnchor: "end",
          offsetLeft: -5,
          offsetTop: 10,
        },
        {
          state: "Wisconsin",
          name: "Madison",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Kansas",
          name: "Kansas City",
          textAnchor: "end",
          offsetLeft: -10,
          offsetTop: -7,
        },
        {
          state: "Kansas",
          name: "Topeka",
          textAnchor: "end",
          offsetLeft: -10,
          offsetTop: 7,
        },
        {
          state: "Missouri",
          name: "St. Louis",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Wyoming",
          name: "Cheyenne",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Florida",
          name: "Jacksonville",
          textAnchor: "end",
          offsetLeft: -5,
          offsetTop: 10,
        },
        {
          state: "Florida",
          name: "Orlando",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Florida",
          name: "Miami",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Florida",
          name: "West Palm Beach",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Washington",
          name: "Spokane",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Alaska",
          name: "Juneau",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Georgia",
          name: "Augusta",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Georgia",
          name: "Savannah",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Hawaii",
          name: "Hilo",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Idaho",
          name: "Idaho Falls",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Illinois",
          name: "Chicago",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Indiana",
          name: "Fort Wayne",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Kentucky",
          name: "Louisville",
          offsetTop: -10,
        },
        {
          state: "Kentucky",
          name: "Lexington",
          offsetTop: 10,
        },
        {
          state: "Michigan",
          name: "Detroit",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Minnesota",
          name: "Duluth",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Minnesota",
          name: "Rochester",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Minnesota",
          name: "Minneapolis",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Missouri",
          name: "Jefferson City",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Nebraska",
          name: "Omaha",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Nebraska",
          name: "Lincoln",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Nevada",
          name: "Las Vegas",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "North Dakota",
          name: "Fargo",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Pennsylvania",
          name: "Philadelphia",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "South Carolina",
          name: "Charleston",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "South Dakota",
          name: "Sioux Falls",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Iowa",
          name: "Cedar Rapids",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Louisiana",
          name: "New Orleans",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Texas",
          name: "Houston",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Texas",
          name: "Austin",
          textAnchor: "end",
          offsetLeft: -10,
        },
        {
          state: "Virginia",
          name: "Virginia Beach",
          textAnchor: "end",
          offsetLeft: -10,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "cities",
      "numOfCandidateByDefault",
      "params",
      "showMoreCandidates",
      "topojson",
      "fips",
      "theme",
    ]),
    geoSelection() {
      return this.$store.getters.geoSelection;
    },
    smAndDown() {
      return window.innerWidth <= 768;
    },
    stateFips() {
      const FIPS_MAP = {
        61: "28",
        60: "27",
      };
      let fips = this.fips.state[this.state];
      if (fips in FIPS_MAP) {
        fips = FIPS_MAP[fips];
      }
      return fips;
    },
    shortWideStates() {
      return [
        "Montana",
        "Nebraska",
        "North Dakota",
        "South Dakota",
        "Wyoming",
        "Oregon",
        "Kansas",
        "Colorado",
        "Tennessee",
        "Kentucky",
        "Virginia",
        "Pennsylvania",
        "Oklahoma",
        "North Carolina",
      ];
    },
  },
  methods: {
    ...mapActions(["setGeoSelection", "setSelectedResultIndex"]),
    ...mapActions({
      showTooltip: "tooltip/showTooltip",
      hideTooltip: "tooltip/hideTooltip",
      setTooltipX: "tooltip/setTooltipX",
      setTooltipY: "tooltip/setTooltipY",
      setTooltipTitle: "tooltip/setTooltipTitle",
      setTooltipCandidates: "tooltip/setTooltipCandidates",
      setTooltipFooter: "tooltip/setTooltipFooter",
      setTooltipIsLeftOfMapCenter: "tooltip/setTooltipIsLeftOfMapCenter",
      setTooltipIsAboveMapCenter: "tooltip/setTooltipIsAboveMapCenter",
    }),
    renderTooltipTitle(result) {
      let title;

      if (this.geoType === "cd") {
        title = result.title || result.full_title;
      } else if (this.geoType === "state") {
        title = result[this.geoType];
      } else if (result.state_name === "Massachusetts") {
        title = `${this.$t("message.district")} ${result.district}`;
      } else if (this.geoType === "county" || this.geoType === "vcu") {
        title = result?.vcu ?? result?.name;
      } else {
        title = `${this.$t("message.district")} ${result.district}`;
        // title = result.short_title;
      }

      if (
        (this.office === "senate" && result.name.includes("Special")) ||
        (result.electionType && result.electionType.includes("special"))
      ) {
        title += " Special";
      } else if (["state_senate", "state_house"].includes(this.office)) {
        title = `${result.abb} ${result.office} ${parseInt(result.district)}`;
      }

      return title;
    },
    renderTooltipCandidates(result) {
      const candidates = result.candidates
        .map((c) => ({ ...c }))
        .sort((a, b) => b.winnner - a.winner || b.percentage - a.percentage)
        .slice(0, this.showMoreCandidates ? result.candidates.length : this.numOfCandidateByDefault)
        .map((candidate) => {
          if (candidate.party_name === "Other" && candidate.votes === 0) return;

          const color = candidate.color.includes("var")
            ? getCSSVarHex(this.theme, candidate.color)
            : candidate.color;

          return {
            color,
            name: `${candidate.first_name} ${candidate.last_name}`,
            percentage: candidate.percentage,
            votes: candidate.votes,
            winner: candidate.winner,
          };
        });

      return candidates;
    },
    renderTooltipFooter(result) {
      if (result.estimated_votes) {
        let estimatedVotesText = "";
        const totalVotes = Object.values(result.votes).reduce((a, b) => a + b);
        const midScenario = totalVotes / result.estimated_votes.estimated_votes_mid > 0.95;
        const percentage = result.precincts.percentage / 100;

        if (totalVotes === 0) {
          estimatedVotesText = `0% ${this.$t("message.in")}`;
        } else if (midScenario && percentage > 0.99) {
          estimatedVotesText = `${this.$t("message.estimated")} >99% ${this.$t("message.in")}`;
        } else if (midScenario) {
          estimatedVotesText = `${this.$t("message.estimated")} >95% ${this.$t("message.in")}`;
        } else {
          const estimatedMid = percentageNoRound(
            totalVotes / result.estimated_votes.estimated_votes_mid
          );
          estimatedVotesText = `${this.$t("message.estimated")} ${estimatedMid} ${this.$t("message.in")}`;
        }

        return `${commas(totalVotes)} ${this.$t("message.votesCounted")}. ${estimatedVotesText}`;
      } else if (!result.precincts.hide) {
        const reportingPrecincts = commas(result.precincts.reporting);
        const totalPrecincts = commas(result.precincts.total);
        return `${result.precincts.percentage.toFixed(2)}% Reporting (${reportingPrecincts} of ${totalPrecincts} precincts)`;
      }

      return "";
    },
    updateTooltipContent(feature) {
      if (this.smAndDown) return;

      const result = this.getSelectedResults(feature);

      if (!result) {
        this.hideTooltip();
        return;
      }

      const title = this.renderTooltipTitle(result);
      this.setTooltipTitle(title);

      const candidates = this.renderTooltipCandidates(result);
      this.setTooltipCandidates(candidates);

      const footer = this.renderTooltipFooter(result);
      this.setTooltipFooter(footer);

      this.showTooltip();
    },
    updateTooltipPosition(event) {
      if (this.smAndDown) return;

      const mapRect = this.mapElement.getBoundingClientRect();
      const cursorIsLeftOfMapCenter = event.pageX - mapRect.left < mapRect.width / 2;
      const cursorIsAboveMapCenter = event.pageY - mapRect.top < mapRect.height / 2;

      this.setTooltipX(event.pageX);
      this.setTooltipY(event.pageY);
      this.setTooltipIsLeftOfMapCenter(cursorIsLeftOfMapCenter);
      this.setTooltipIsAboveMapCenter(cursorIsAboveMapCenter);
    },
    drawMap() {
      const self = this;

      d3.selection.prototype.moveToFront = function () {
        return this.each(function () {
          if (this.parentNode) this.parentNode.appendChild(this);
        });
      };

      const map = d3.select(`#${self.id}`);
      const svgId = `${self.id}-svg`;
      const prevSvg = document.getElementById(svgId);
      if (prevSvg) {
        prevSvg.parentNode.removeChild(prevSvg);
      }
      map.select(`#${svgId}`).remove();
      const container = map.node();
      this.mapElement = container;
      let width = null;
      let height = 400;
      if (self.shortWideStates.includes(self.state)) {
        height = 250;
      }
      if (container) {
        width = container.clientWidth;
      }

      this.svg = d3
        .select(`#${self.id}`)
        .append("svg")
        .attr("aria-label", "Election Results Map")
        .attr("tabindex", 0)
        .attr("width", width)
        .attr("height", height)
        .attr("id", svgId)
        .style("outline", "none")
        .on(
          "click",
          function (event) {
            if (event.defaultPrevented) {
              event.stopPropagation();
            }
            // self.setGeoSelection(null)
          },
          true
        );

      let projection = self.projection.fitSize([width, height], self.geojson);
      let path = d3.geoPath().projection(projection);

      self.g = this.svg.append("g");

      self.g
        .selectAll("path")
        .data(self.geojson.features)
        .enter()
        .append("path")
        .attr("stroke", "#000")
        .attr("d", path)
        .style("fill", self.getFillColor)
        .style("opacity", self.config.style.opacity)
        .style("stroke-width", self.config.style.strokeWidth)
        .on("click", (_event, feature) => self.pathClick(feature))
        .on("mouseover", (_event, feature) => self.updateTooltipContent(feature))
        .on("mousemove", (event) => debounceAF(self.updateTooltipPosition(event)))
        .on("mouseout", () => self.hideTooltip());

      if (this.params.showCities) this.drawCities();

      self.selectionHighlighting();
    },
    resetSelected() {
      this.g
        .selectAll("path")
        .style("opacity", "1")
        .style("stroke", "#fff")
        .style("stroke-width", this.config.style.strokeWidth);
    },
    highlightSelected(name, d3Obj, key) {
      this.resetSelected();

      d3.select(d3Obj).moveToFront().style("stroke", "#222").style("stroke-width", "1.5px");

      this.g.selectAll("path").each(function (d) {
        if (d.properties[key] !== name) {
          d3.select(this).style("opacity", "0.5");
        } else {
          d3.select(this).style("opacity", "1");
        }
      });
    },
    getEstimatedVotes(result) {
      let perc = result.totalVotes / result.estimated_votes.estimated_votes_mid;
      if (result.totalVotes === 0) {
        return `0% ${this.$t("message.in")}.`;
      } else if (perc < 0.01) {
        return `< 1% ${this.$t("message.in")}.`;
      } else if (perc > 0.99) {
        return `${this.$t("message.estimated")} > 99% ${this.$t("message.in")}.`;
      } else {
        perc = percentage(perc);
        return `${this.$t("message.estimated")} ${perc} ${this.$t("message.in")}.`;
      }
    },
    getCityOffset(state, city) {
      const cityOffset = this.citiesWithOffsets.find((c) => c.state === state && c.name === city);

      if (cityOffset === undefined) return this.standardCityOffset;

      return {
        textAnchor: cityOffset.textAnchor || this.standardCityOffset.textAnchor,
        offsetLeft: cityOffset.offsetLeft || this.standardCityOffset.offsetLeft,
        offsetTop: cityOffset.offsetTop || this.standardCityOffset.offsetTop,
      };
    },
    drawCities() {
      const self = this;
      let cities = self.svg.append("g");
      const filteredCities = self.cities.features.filter(
        (c) => c.properties.ADM1NAME === this.state
      );

      cities
        .selectAll("circle")
        .data(filteredCities)
        .enter()
        .append("circle")
        .attr("r", 4.5)
        .attr("fill", "black")
        .attr("transform", function (d) {
          return (
            "translate(" + self.projection([d.properties.LONGITUDE, d.properties.LATITUDE]) + ")"
          );
        });
      cities
        .selectAll(".cities")
        .data(filteredCities)
        .enter()
        .append("text")
        .attr("class", "city-label shadow");
      cities
        .selectAll(".cities")
        .data(filteredCities)
        .enter()
        .append("text")
        .attr("class", "city-label");
      cities
        .selectAll(".city-label")
        .attr("transform", function (d) {
          return "translate(" + self.projection(d.geometry?.coordinates) + ")";
        })
        .attr("dy", ".25em")
        .text(function (d) {
          return d.properties.NAME;
        })
        .attr("font-size", "14px")
        .attr("x", (d) => self.getCityOffset(d.properties.ADM1NAME, d.properties.NAME).offsetLeft)
        .attr("y", (d) => self.getCityOffset(d.properties.ADM1NAME, d.properties.NAME).offsetTop)
        .attr(
          "text-anchor",
          (d) => self.getCityOffset(d.properties.ADM1NAME, d.properties.NAME).textAnchor
        );
    },
  },
};
